import { AdGlobalRefreshContext } from 'contexts/AdGlobalRefreshContext';
import { useContext, useState } from 'react';
import { AdProps } from '.';
import ConditionalRefreshAd from './ConditionalRefreshAd';

interface Props {
  isVisible: boolean;
}

export default function VisibleAd(props: Props & AdProps): JSX.Element {
  const { shouldGlobalAdsRefresh } = useContext(AdGlobalRefreshContext);
  const [viewed, setViewed] = useState(false);

  if (!viewed && props.isVisible) {
    setViewed(true);
  }
  return <ConditionalRefreshAd load={viewed} shouldRefresh={shouldGlobalAdsRefresh} {...props} />;
}
